








import colorable from '../../mixins/colorable/colorable';
import sizeable from '../../mixins/sizeable/sizeable';
import mixins from '../../mixins';

export default mixins(colorable, sizeable).extend({
  mixins: [colorable, sizeable],
  props: {
    flat: { type: Boolean, default: false },
  },
  computed: {
    classList() {
      return {
        'p-toolbar': true,
        spacious: this.spacious,
        dense: this.dense,
        'color-base': this.color === undefined,
        [`color-${this.color}`]: this.color !== undefined,
        flat: this.flat,
      };
    },
  },

});
